import { gql } from '@apollo/client'

// All amounts on these types are baht floats, not satangs.
const PREVIEW_FIELDS = `
    lineItems {
        lineItemId
        itemId
        name
        quantity
        currentSinglePrice
        onlineSinglePrice
        currentTotalPrice
        onlineTotalPrice
        difference
        discountSources
        excludedFromDiscountLadder
    }
    lineItemsDiscountTotal
    currentLineItemsTotal
    onlineLineItemsTotal
    skippedLineItemCount
    discountLadder {
        id
        campaignName
        description
        expireDate
        applicable
        eligibleItemsTotal
        discountAmount
        currentTier { id minimumPrice discountPrice }
        nextTier { id minimumPrice discountPrice }
        toReachNextTier
        tiers { id minimumPrice discountPrice }
    }
    limitedTimeOffer {
        id
        discountPercent
        minimumPrice
        endDate
        participatingItemsTotal
        discountAmount
    }
    voucher {
        id
        code
        found
        voucherType
        displayVoucherType
        minimumPrice
        couponDiscount
        shippingCostDiscount
        discountAmount
    }
    currentOrderDiscount
    onlineOrderDiscount
`

export const ONLINE_DISCOUNT_PREVIEW_QUERY = gql`
    query OrderOnlineDiscountPreview($orderId: String!, $voucherCode: String) {
        orderOnlineDiscountPreview(orderId: $orderId, voucherCode: $voucherCode) {
            ${PREVIEW_FIELDS}
        }
    }
`

export const APPLY_ONLINE_DISCOUNT_MUTATION = gql`
    mutation ApplyOrderOnlineDiscount(
        $orderId: String!
        $voucherCode: String
        $applyLineItemPrices: Boolean
        $applyOrderDiscount: Boolean
    ) {
        applyOrderOnlineDiscount(
            orderId: $orderId
            voucherCode: $voucherCode
            applyLineItemPrices: $applyLineItemPrices
            applyOrderDiscount: $applyOrderDiscount
        ) {
            order {
                id
                number
                discount
            }
            preview {
                ${PREVIEW_FIELDS}
            }
            errors
        }
    }
`
